import React, { useMemo } from "react";
import { HomeSectionMenuItem, Item } from "../../../../components/Menu";
import { CategoryType } from "../../../../constants";
import { LocalizationMessages } from "../../../../localization/messages";
import { PageContextUtils, UrlUtils } from "../../../../utils";
import { links } from "./Config.resource";
import {
  useCategoriesSetter,
  useAccountCommunicationHandlers
} from "../../../../hooks";
import { AppFeatures } from "../../../../constants/featureFlags";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../../../redux/selectors";
import { useFeature } from "../../../../hooks/useFeature";

const HomeSection = () => {
  const { contentLangId } = PageContextUtils.getLocalizationData();
  const isVip = useSelector(UserContextSelectors.isVip);
  const isMadeForYouActive = useFeature(AppFeatures.MADE_FOR_YOU);
  const { openChallengesOrPromotions } = useAccountCommunicationHandlers();
  const isMobile = useSelector(UserContextSelectors.isMobile);

  const items = useMemo(
    () => ({
      home: new Item({
        URL: UrlUtils.getSEOUrl(links.home),
        title: LocalizationMessages.home,
        iconKey: "home"
      }),
      promotions: new Item({
        URL: UrlUtils.getSEOUrl(isVip ? links.promotionsVIP : links.promotions),
        title: isVip
          ? LocalizationMessages.promotionsVIP
          : LocalizationMessages.promotions,
        iconKey: "offers"
      }),
      challenges: new Item({
        URL: undefined,
        title: LocalizationMessages.challenges,
        iconKey: "challenges"
      }),
      live: new Item({
        URL: UrlUtils.getSEOUrl(links.liveNow),
        title: LocalizationMessages.liveNow,
        iconKey: "live"
      }),
      recommendations: new Item({
        URL: UrlUtils.getSEOUrl(links.recommendations),
        title: LocalizationMessages.recommendations,
        iconKey: "recommendations"
      }),
      madeForYou: new Item({
        URL: UrlUtils.getSEOUrl(links.madeForYou[contentLangId]),
        title: LocalizationMessages.madeForYou,
        iconKey: "recommendations"
      }),
      betFeed: new Item({
        URL: UrlUtils.getSEOUrl(links.betFeed),
        title: LocalizationMessages.betFeed,
        iconKey: "bet-feed"
      })
    }),
    [contentLangId, isVip]
  );

  useCategoriesSetter(CategoryType.HomeSection, items);

  return (
    <>
      <HomeSectionMenuItem item={items.home} dataTestId="uc-home" />
      <HomeSectionMenuItem item={items.promotions} dataTestId="uc-offers" />
      {isMobile && (
        <HomeSectionMenuItem
          item={items.challenges}
          dataTestId="uc-challenges"
          onClick={openChallengesOrPromotions}
        />
      )}
      <HomeSectionMenuItem item={items.live} dataTestId="uc-live" />
      {isMadeForYouActive ? (
        <HomeSectionMenuItem
          item={items.madeForYou}
          dataTestId="uc-made-for-you"
        />
      ) : (
        <HomeSectionMenuItem
          item={items.recommendations}
          dataTestId="uc-recommendations"
        />
      )}
      <HomeSectionMenuItem item={items.betFeed} dataTestId="uc-betFeed" />
    </>
  );
};

export default React.memo(HomeSection);
